import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { checkAuthorized, getClientToken } from '../../reducers/oauth/duck';
import { getProfile } from '../../reducers/user/duck';
import AuthFlow from './AuthFlow';

const mapStateToProps = ({
  oauthStore: { status, error, isAuthorized },
  userStore: { profile, id },
}) => ({
  isAuthorized,
  status,
  error,
  profile,
  id,
});

const mapDispatchToProps = {
  checkAuthorized,
  getClientToken,
  getProfile,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthFlow));



// WEBPACK FOOTER //
// ./src/containers/AuthFlow/index.js